module.exports = __webpack_public_path__ + "nc_static/media/internalServerImg.00618d0a.png";